import React, { useState } from "react";
import {
  FormControl,
  FormControlLabel,
  Checkbox as MuiCheckbox,
  TextField,
} from "@mui/material";

function MultipleCheckbox(props) {
  const { name, value, onChange, options, style } = props;
  const [searchTerm, setSearchTerm] = useState("");

  const convertToEventParam = (name, id) => {
    const isChecked = value.includes(id);
    if (isChecked) {
      return {
        target: {
          name: name,
          value: value.filter((item) => item !== id),
        },
      };
    } else {
      return {
        target: {
          name: name,
          value: [...value, id],
        },
      };
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredOptions = options.filter((option) =>
    option.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const styleDefault = {
    width: "100%",
  };

  return (
    <FormControl sx={{ ...styleDefault, ...style }}>
      <TextField
        placeholder="Search..."
        value={searchTerm}
        onChange={handleSearch}
        fullWidth
        margin="normal"
      />
      {filteredOptions.map((option) => (
        <FormControlLabel
          key={option.id}
          control={
            <MuiCheckbox
              name={name}
              color="primary"
              checked={value.includes(option.id)}
              onChange={(e) => onChange(convertToEventParam(name, option.id))}
            />
          }
          label={option.name.toLowerCase()}
        />
      ))}
    </FormControl>
  );
}

export default MultipleCheckbox;
